import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  Box, Typography, Avatar, Table, TableBody,
  TableCell, TableHead, TableRow, Select, MenuItem, Chip,
} from "@mui/material";
import config from "../../../config";
import { capitalizeFirstLetter } from "../../../utils/Utils";
import moment from "moment";

const statusStyle = (status) => {
  const s = status.split("_")[0];
  if (s === "available") return { color: "#4caf50", bg: "rgba(76,175,80,0.1)", border: "rgba(76,175,80,0.2)" };
  if (s === "nfs") return { color: "#ff9800", bg: "rgba(255,152,0,0.1)", border: "rgba(255,152,0,0.2)" };
  if (s === "sold") return { color: "#888", bg: "rgba(255,255,255,0.05)", border: "rgba(255,255,255,0.08)" };
  return { color: "#888", bg: "rgba(255,255,255,0.05)", border: "rgba(255,255,255,0.08)" };
};

const headCellSx = { color: "#555", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", whiteSpace: "nowrap", borderColor: "#222", backgroundColor: "#111" };

const SoldItemTable = ({ seller }) => {
  const filters = [
    { name: "Last 1 day", value: 1 },
    { name: "Last 7 days", value: 7 },
    { name: "Last 15 days", value: 15 },
  ];
  const headings = ["", "Name", "Category", "Last Updated", "Price", "Status"];
  const [filter, setFilter] = useState(15);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    if (!seller?.id) return;
    const load = async () => {
      try {
        const res = await axios.get(
          `${config.SERVER_URL}/api/v1/seller/${seller.id}/animals?filter_days=${filter}`
        );
        if (res.status === 200) setListings(res.data.data || []);
      } catch {}
    };
    load();
  }, [filter, seller]);

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2.5, py: 1.5, borderBottom: "1px solid #222" }}>
        <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#fff" }}>
          Recent Animal Listings
        </Typography>
        <Select
          value={filter}
          size="small"
          onChange={(e) => setFilter(e.target.value)}
          sx={{
            fontSize: "12px", color: "#888", height: 30,
            ".MuiOutlinedInput-notchedOutline": { borderColor: "#333" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#555" },
            ".MuiSvgIcon-root": { color: "#555" },
          }}
        >
          {filters.map(f => (
            <MenuItem key={f.value} value={f.value} sx={{ fontSize: "12px" }}>{f.name}</MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        {listings.length > 0 ? (
          <Table size="small" sx={{ "& td": { borderColor: "#1e1e1e" } }}>
            <TableHead>
              <TableRow>
                {headings.map(h => (
                  <TableCell key={h} align="center" sx={headCellSx}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {listings.map((data) => {
                const { color, bg, border } = statusStyle(data.status);
                const label = data.status.split("_")[0] === "nfs"
                  ? "NFS"
                  : capitalizeFirstLetter(data.status.split("_")[0]);
                return (
                  <TableRow
                    key={data.id}
                    onClick={() => window.open(`/listing/${data.id}`, "_blank")}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "rgba(255,192,1,0.03)" } }}
                  >
                    <TableCell align="center" sx={{ py: 1, borderColor: "#1e1e1e", width: 52 }}>
                      <Avatar src={data.media?.[0]?.url} alt={data.name} sx={{ width: 36, height: 36, mx: "auto" }} />
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#ccc", fontSize: "13px", borderColor: "#1e1e1e" }}>
                      {data.name}
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#888", fontSize: "13px", borderColor: "#1e1e1e" }}>
                      {data.category?.name}
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#666", fontSize: "12px", whiteSpace: "nowrap", borderColor: "#1e1e1e" }}>
                      {moment(data.last_updated).fromNow()}
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#FFC001", fontSize: "13px", fontWeight: 700, borderColor: "#1e1e1e" }}>
                      ${data.price}
                    </TableCell>
                    <TableCell align="center" sx={{ borderColor: "#1e1e1e" }}>
                      <Chip
                        label={label}
                        size="small"
                        sx={{ backgroundColor: bg, color, fontSize: "11px", fontWeight: 700, height: 22, border: `1px solid ${border}` }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography sx={{ color: "#555", fontSize: "13px", textAlign: "center", py: 4 }}>
            No listings found for this period
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ Seller }) => ({ seller: Seller.seller });
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SoldItemTable);
